let offers;
let theProduct;

function getCurrentlySelectedVariant(product) {
  selectedVariant = product.variants.find(
    (i) => i.id == mulberryShop.selectedVariantId
  );
  if (!selectedVariant) {
    selectedVariant = product.variants[0];
  }
  mulberryShop.selectedVariantId = selectedVariant.id;
  return selectedVariant;
}

async function mulberryPdpInit() {
  const HAS_MODAL = mulberry.core.settings.has_modal;
  const HAS_INLINE = mulberry.core.settings.has_inline || true;
  if (window.location.pathname.indexOf("/products/") === -1) {
    return;
  }
  
  if (!HAS_MODAL && !HAS_INLINE) {
    return;
  }
  const mulberryDiv = document.createElement('div');
  mulberryDiv.classList.add('mulberry-pdp-inline');
  mulberryDiv.style = "min-height: 100px;";
  document.querySelector('.mulberry-box').appendChild(mulberryDiv)

  let response = await mulberryShop.getProductData(
    mulberryShop.getProductUrl()
  );
  theProduct = response.product;
  let selectedVariant = getCurrentlySelectedVariant(theProduct);
  offers = await mulberry.core.getWarrantyOffer({
    id: selectedVariant.id,
    title: theProduct.title,
    price: selectedVariant.price,
    detail: theProduct,
  });

  if (HAS_INLINE) {
    window.pdpInline = await mulberry.inline.init({
      offers: offers,
      settings: mulberry.core.settings,
      selector: ".mulberry-pdp-inline",
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected;
        if (warranty.isSelected) {
          window.selectedOffer = warranty;
        } else {
          window.selectedOffer = null;
        }
      },
    });
  }
  if (HAS_MODAL) {
    window.pdpModal = await mulberry.modal.init({
      offers: offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const result = await mulberryShop.getWarrantyVariant(warranty);
        await mulberryShop.addWarrantyToCart(
          result.shopify_variant_id,
          theProduct,
          warranty
        );
        document.querySelector("#last-form #check-all")?.click();
        mulberry.modal.close();
      },
      onWarrantyDecline: async () => {
        document.querySelector("#last-form #check-all")?.click();
        mulberry.modal.close();
      },
    });
  }
}

document
  ?.querySelector("#last-form #check-all-temp")
  ?.addEventListener("click", async function (e) {
    e.preventDefault();
    const HAS_MODAL = mulberry.core.settings.has_modal;
    const HAS_INLINE = mulberry.core.settings.has_inline || true;

    const spinner = this.querySelector(".loading__spinner");
    if (spinner) {
      spinner.classList.remove("hidden");
    }

    this.disabled = true;

    const handleClick = async () => {
      if (HAS_INLINE && window.selectedOffer && window.pdpInline) {
        await addWarranty();
      } 
      // else if (HAS_MODAL && !window.selectedOffer && window.pdpModal) {
      //   window.pdpModal.open();
      // } 
      else {
        document.querySelector("#last-form #check-all")?.click(); 
      }
    };
    await Promise.resolve().then(handleClick);
    this.disabled = false;
  });

async function addWarranty() {
  addToCartButtonClicked = true;
  if (!offers || offers.length == 0) {
    return;
  }
  try {
    let result;
    cart = await fetch("/cart.js");
    cartJson = await cart.json();
    if (window.selectedOffer) {
      result = await mulberryShop.getWarrantyVariant(
        window.selectedOffer.offer
      );
      const final = await mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          ...theProduct,
          title: theProduct.title,
          variantId: mulberryShop.selectedVariantId,
        },
        window.selectedOffer.offer
      );
      document.querySelector("#last-form #check-all")?.click();
      window.pdpInline.deselectOffer();
      window.selectedOffer = null;
    }
  } catch (err) {
    console.log("mulberry error: ", err);
  }
  mulberry.inline.deselectOffer();
}

document.addEventListener('mulberry-shopify:warranty-added', async (e) => {
  // await removeAndSyncWarranties();
})

document.addEventListener("mulberry-shopify:loaded", async function (e) {
  window.mb_gtm_is_disabled = true
  setupFetchListeners();
  // await removeAndSyncWarranties();
  if (document.location.href.includes("/products/")) {
    mulberryPdpInit();
  }

  let lastUrl = location.href;

  let theVariant;
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
    
  async function handleUrlChange() {
    var variant = getUrlParameter('variant');  
    if (variant && theVariant !== variant && window.pdpInline) {
      theVariant = variant

      window.selectedOffer = null;
      window.pdpInline.deselectOffer();
      
      mulberryShop.selectedVariantId = variant
      selectedVariant = getCurrentlySelectedVariant(theProduct);
      offers = await mulberry.core.getWarrantyOffer({
        id: selectedVariant.id,
        title: theProduct.title,
        price: selectedVariant.price,
        detail: theProduct,
      });

      if(offers && offers.length) { 
        document.querySelector('.mulberry-box').style.display = 'block';
        if (mulberry.core.settings.has_inline) {
          window.pdpInline.updateOffer(offers);
        }
        
        // if (mulberry.core.settings.has_modal) {
        //   window.pdpModal.updateOffer(offers);
        // }
      } else {
        document.querySelector('.mulberry-box').style.display = 'none';
      }
    }
  }
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function() {
      if (lastUrl !== location.href) {
        lastUrl = location.href;
        handleUrlChange();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  handleUrlChange();
});

document.addEventListener("fetch:cart-change", async function () {
  // await removeAndSyncWarranties();
});

document.addEventListener("fetch:cart-add", async function () {
  // await removeAndSyncWarranties();
});

async function removeAndSyncWarranties(reload = false) {
  return; 
  let response = await fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  let firstCart = await response.json();
  const originalItemCount = firstCart.item_count;

  // Filter items
  firstCart.items = firstCart.items.filter(
    item => item?.properties?._variantId !== 'sectional'
  );

  try {
    const newCart = await mulberryShop.removeDetachedWarranty(firstCart);
    const updatedCart = await mulberryShop.cart.syncQuantities(newCart);

    if(updatedCart && updatedCart.items && !updatedCart.items.length) {
      document.querySelector('.drawer.active')?.classList.add('is-empty');
      const bubble = document.querySelector(".cart-count-bubble");
      const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
      const hiddenSpan = bubble.querySelector('.visually-hidden');
      if (visibleSpan) visibleSpan.textContent = 0;
      if (hiddenSpan) hiddenSpan.textContent = `0 items`;    
    }
    // else {
    //   await mulberryShop.cart.init();
    //   mulberryShop.cart.render();
    // }

  } catch (error) {
    console.error('Error during warranty removal and cart sync:', error);
  }
}

function setupFetchListeners() {
  const { fetch: origFetch } = window;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    let requestUrl = args[0];
    if (requestUrl.includes("cart/change") || requestUrl.includes("cart/add")) {
      response
        .clone()
        .json()
        .then((body) => {
          if (requestUrl.includes("cart/add")) {
            const fetchAddCustomEvent = new CustomEvent("fetch:cart-add");
            document.dispatchEvent(fetchAddCustomEvent);
          } else if (requestUrl.includes("cart/change")) {
            const fetchChangeCustomEvent = new CustomEvent("fetch:cart-change");
            document.dispatchEvent(fetchChangeCustomEvent);
          } else if (requestUrl.includes("cart/update")) {
            const fetchUpdateCustomEvent = new CustomEvent("fetch:cart-update");
            document.dispatchEvent(fetchUpdateCustomEvent);
          } else {
            if (requestUrl.includes("cart.php")) {
              const fetchCartCustomEvent = new CustomEvent("fetch:cart-page");
              document.dispatchEvent(fetchCartCustomEvent);
            }
          }
        })
        .catch((err) => console.error(err));
    }
    return response;
  };
}